import React from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClearIcon from '@mui/icons-material/Close';
import {Autocomplete, TextField, Box, Tooltip, FormHelperText} from '@mui/material';
import {Controller} from 'react-hook-form';

// eslint-disable-next-line react/prop-types
export default ({control, error, helperText, name, placeholder, disabled}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({field}) => {
        const safeValue = Array.isArray(field.value) ? field.value : [];
        const tooltipTitle = safeValue.join(', ');

        return (
          <Tooltip title={tooltipTitle} placement="top">
            <Autocomplete
              error={error}
              disabled={disabled}
              sx={{
                // force height of the whole input
                '& .MuiInputBase-root': {
                  height: 38,
                  fontSize: 12,
                  padding: '0 8px',

                  // align vertically
                  display: 'flex',
                  alignItems: 'center',
                  flexWrap: 'nowrap',

                  // optional: match your TextField styling (rounded + outline)
                  borderRadius: '6px',

                  overflowX: 'auto',
                  whiteSpace: 'nowrap',

                  // hide scrollbar (optional)
                  scrollbarWidth: 'none',
                  '&::-webkit-scrollbar': {display: 'none'}
                },

                // font size for typed text
                '& .MuiInputBase-input': {
                  fontSize: 12,
                  whiteSpace: 'nowrap',
                  padding: 0 // removes extra vertical padding,
                },

                // placeholder font
                '& .MuiInputBase-input::placeholder': {
                  fontSize: 12,
                  opacity: 0.6
                },

                // size for the tags wrapper area
                '& .MuiAutocomplete-tag': {
                  fontSize: 12,
                  whiteSpace: 'nowrap'
                },

                '& .MuiOutlinedInput-root.Mui-disabled': {
                  backgroundColor: 'rgba(0,0,0,0.05)'
                },

                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none'
                },

                // fix excessive top/bottom padding inside Autocomplete
                '& .MuiOutlinedInput-root': {
                  paddingTop: 0,
                  paddingBottom: 0,
                  transition: 'height 0.2s',
                  border: theme => `1px solid ${theme.palette.grey[400]}`,
                  '&.Mui-focused': {
                    width: '100%',
                    border: theme => `2px solid ${theme.palette.primary.main}`
                  },
                  ...(error ? {border: '1px solid red !important'} : {})
                }
              }}
              multiple
              freeSolo
              options={[]} // no predefined options
              value={safeValue}
              onChange={(event, newValue) => {
                field.onChange(newValue); // important!
              }}
              popupIcon={<ArrowDropDownIcon />}
              clearIcon={null}
              renderTags={(value, getTagProps) =>
                (Array.isArray(value) ? value : []).map((option, index) => (
                  <Box
                    key={option}
                    sx={{
                      fontSize: 12,
                      display: 'flex',
                      alignItems: 'center',
                      padding: '2px 8px',
                      borderRadius: '6px',
                      backgroundColor: disabled ? 'rgba(0,0,0,0.1)' : 'secondary.main',
                      color: 'white !important',
                      marginRight: '4px'
                    }}
                  >
                    {option}
                    <ClearIcon
                      onClick={getTagProps({index}).onDelete}
                      sx={{
                        color: 'white',
                        fontSize: 16,
                        marginLeft: '6px',
                        cursor: 'pointer'
                      }}
                    />
                  </Box>
                ))
              }
              renderInput={params => (
                <TextField
                  {...params}
                  placeholder={
                    Array.isArray(field.value) && field.value.length > 0
                      ? ' ' // space instead of empty string prevents layout jump
                      : placeholder
                  }
                />
              )}
            />
            {helperText && error && (
              <FormHelperText error sx={{fontSize: 11, lineHeight: 1.1}}>
                {helperText}
              </FormHelperText>
            )}
          </Tooltip>
        );
      }}
    />
  );
};
